import { Directive, Input, ElementRef, HostBinding } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[tabNavBarLink]',
  exportAs: 'tabNavBarLink',
})
export class TabNavBarLinkDirective {
  private isActive: boolean;

  @Input()
  get active(): boolean {
    return this.isActive;
  }
  set active(value: boolean) {
    if (value !== this.isActive) {
      this.isActive = value;
    }
  }

  @HostBinding('class') tabClass = 'tabs-title';
  @HostBinding('class.active') get activeStatus() {
    return this.active;
  }

  constructor(public elementRef: ElementRef) {}
}
